import { authApi } from '@mathflat/domain/Auth'

import WebviewService from '@/service/webview.service'
import {
  assertServiceRedirectUri,
  getServiceBaseUrl,
  getServiceCallbackUrl,
  redirectWithToken,
} from '@/utils/serviceConnectUtils'

export function getScienceflatBaseUrl() {
  return getServiceBaseUrl('SCIENCEFLAT')
}

function assertScienceflatRedirectUri(redirectUri: string) {
  if (!assertServiceRedirectUri('SCIENCEFLAT', redirectUri)) {
    throw new Error('Invalid scienceflat redirectUri')
  }
}

/** 이미 동의된 사용자 — 토큰만 보내서 scienceflat 이동 (다른 계정 로그인 시 scienceflat 로그인 페이지로 이동됨) */
export async function openScienceflat() {
  await redirectWithToken(getServiceCallbackUrl('SCIENCEFLAT'), {
    openInNewTab: !WebviewService.isAppAndroid,
    reissue: true,
  })
}

/** 동의 API 호출 후 토큰 보내서 scienceflat 이동 */
export async function connectToScienceflat(redirectUri: string, openInNewTab = false) {
  assertScienceflatRedirectUri(redirectUri)
  // postAllowServiceType await 전(user gesture context 안)에 미리 빈 창을 열어둠
  const popup = openInNewTab ? window.open('', '_blank') : null
  if (popup) popup.opener = null
  await authApi.grantServiceTypeAccess({ serviceType: 'SCIENCEFLAT' })
  await redirectWithToken(redirectUri, { openInNewTab, preOpenedPopup: popup, reissue: true })
}
